import { Stack, Typography } from "@mui/material";
import type { FC } from "react";
import { ActivityAddressLink } from "web_myplann/Activities/Components/ActivityAddressLink";
import { useFormatDateTimeByClientActivity } from "web_myplann/Activities/Hooks/useActivitiesFormatDateAndTimes";
import type { ActivityDetailResponseDTO } from "web_myplann/Infrastructure/Api/Api";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { DetailRow } from "web_myplann/Portfolio/Components/Redesign/Detail/DetailRow";
import { useFormatUserWithType } from "web_myplann/Shared/Hooks/useFormatUserWithType";

const R = Resources.Activity.Detail;

type Props = {
	event: ActivityDetailResponseDTO;
};

export const ActivityBasicInfoSection: FC<Props> = ({ event }) => {
	const { t } = useResource();
	const formatDateTime = useFormatDateTimeByClientActivity();
	const formatUserWithType = useFormatUserWithType();

	return (
		<>
			<Typography variant="sectionLabel">{t(R.BasicInfo.title)}</Typography>
			<Stack bgcolor="background.paper">
				<DetailRow
					label={t(R.BasicInfo.Name)}
					element={
						event.title ? (
							<Typography variant="bodyStrong" textAlign="right">
								{event.title}
							</Typography>
						) : undefined
					}
				/>
				<DetailRow
					label={t(R.BasicInfo.Type)}
					value={t(Resources.Activity.List.ActivityType[event.type])}
				/>
				<DetailRow label={t(R.BasicInfo.Date)} value={formatDateTime(event)} />
				{event.place && (
					<DetailRow
						label={t(R.BasicInfo.Address)}
						element={<ActivityAddressLink place={event.place} />}
					/>
				)}
				<DetailRow
					label={t(R.BasicInfo.CreatedBy)}
					value={formatUserWithType(event.author)}
				/>
			</Stack>
		</>
	);
};
